<template>
  <full-screen-spinner v-if="loading" />
  <div
    v-else
    class="page-layout"
    :style="{ 'grid-template-rows': hasTopBar ? '4.5rem 1fr' : '1fr' }"
  >
    <div
      v-if="hasTopBar"
      class="_top-bar"
    >
      <slot name="topBar" />
    </div>
    <div
      class="_frame"
      :style="{ width: calculatedWidth, height }"
    >
      <slot />
    </div>
  </div>
</template>

<script>
import FullScreenSpinner from 'shared/components/FullScreenSpinner.vue';
import usePageExport from '@/composables/export/page-export';
import { SIDEBAR_SERVICE } from '@/lib/constants';
import { inject } from 'vue';

export default {
  name: 'PageLayout',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    modal: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 0,
    },
    hideTopBar: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { isPrint } = usePageExport();
    const { containerWidth } = inject(SIDEBAR_SERVICE);
    return { isPrint, containerWidth };
  },
  components: { FullScreenSpinner },
  data() {
    return { headerHeight: '4.5rem' };
  },
  computed: {
    hasTopBar() {
      return !this.hideTopBar;
    },
    height() {
      if (this.isPrint) {
        return 'auto';
      }

      if (!this.hasTopBar) {
        return 'var(--viewport-height-100)';
      }

      if (this.modal) {
        return `calc(var(--viewport-height-100) - 14.4rem - ${this.headerHeight})`;
      }

      return `calc(var(--viewport-height-100) - ${this.headerHeight}`;
    },
    calculatedWidth() {
      if (this.isPrint) {
        return 'calc(100vw - 6rem)';
      }

      if (this.$store.state.breakpoint.smAndDown) {
        return '100vw';
      }

      if (this.modal) {
        return this.$modalSizes.xl;
      }

      if (this.width !== 0) {
        return `${this.width}px`;
      }

      return `${this.containerWidth}px`;
    },
  },
};
</script>

<style
    scoped
    lang="scss"
    type="text/scss"
>
  .page-layout {
    display: grid;
    grid-template-columns: 1fr;
    height: 100%;
    border-radius: $default-border-radius;

    ._frame {
      position: relative;
      max-height: 100%;
    }
  }
</style>
